import React, { useState, useRef, useEffect,useCallback } from 'react';
import {  useDispatch, useSelector} from 'react-redux';
import filter_list from '../../../Assets/filter_list.png';
import './ApplyFilterStyle.scss';

import { OverlayPanel } from 'primereact/overlaypanel';
import { Badge } from 'primereact/badge';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { successToastStyle,errorToastStyle } from '../../../Shared/Utils/ToastUtils';
import { useTranslation } from 'react-i18next';
import { fetchDistrictId, setDistrictId, setTalukaId,setPHCId, SendTaluka,SendPHC } from '../../../Store/Dashboard/DashboardActions';
import { getGlobalDistrictId, getTaluka,getPhc } from '../../../Store/Dashboard/DashboardSelectors';
import { useLanguage } from '../../../Layout/ChangeLanguage/LanguageProvider';

const ApplyFilter = () => {
  const {selectedLanguageId} = useLanguage();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const disId = useSelector(getGlobalDistrictId).result
  const phc = useSelector(getPhc).result
  const Taluka = useSelector(getTaluka).result
  const filterOverlay = useRef(null);
  const isFilterApplied = false;
  const [selectedDistrict, setSelectedDistrict] = useState(disId);
  const [selectedTaluka, setSelectedTaluka] = useState(Taluka);
  const [selectedPhc, setSelectedPhc] = useState('');
  const [searchState, setSearchState] = useState('Maharashtra');
  const fetchData = useCallback(() => {
    try {
        dispatch(setDistrictId(selectedLanguageId));
        if (selectedDistrict) {
            dispatch(setTalukaId(selectedDistrict, selectedLanguageId));

            if (selectedTaluka) {
                dispatch(setPHCId(selectedTaluka, selectedLanguageId));
            }
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}, [dispatch, selectedDistrict, selectedTaluka, selectedLanguageId]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

const shouldClearFilters = (languageId) => {
    return languageId === 1 || languageId === 2;
};
const handleSearch = () => {
  if (!selectedPhc) {
      toast.error('Choose at least one field!', {
          style: errorToastStyle,
      });
      return;
  }
  dispatch(fetchDistrictId(selectedDistrict));
  dispatch(SendTaluka(selectedTaluka));
  dispatch(SendPHC(selectedPhc));

  toast.success('Searched Successfully!', {
      style: successToastStyle,
  });
};
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const years = [
    2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,2025,2026
  ];
  const currentMonthIndex = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const [searchYear, setSearchYear] = useState(currentYear);
  const [searchMonth, setSearchMonth] = useState(currentMonthIndex + 1);
  const handleClear = () => {
    setSelectedPhc('');
    setSelectedDistrict('');
    setSelectedTaluka('');
    setSearchMonth('');
    setSearchYear('');
  };
  useEffect(() => {
    if (shouldClearFilters(selectedLanguageId)) {
        handleClear();
    }
}, [selectedLanguageId]);
  const monthOptions = months.map((month, index) => ({
    label: month,
    value: index + 1,
  }));
  const yearOptions = years.map((year) => ({
    label: year.toString(),
    value: year,
  }));

const districtOptions = (disId && disId.map(district => ({
    label: district.districtName,
    value: district.districtId
}))) || [];


const talukaOptions = (Taluka && Taluka.map(taluka => ({
    label: taluka.talukaName,
    value: taluka.talukaId
}))) || [];

const phcOptions = (phc && phc.map(phcs => ({
    label: phcs.phcName,
    value: phcs.phcId
})))  || [];



const handleSelection = (selectedValue, setSelected, options) => {
  setSelected(selectedValue);

  if (!Array.isArray(selectedValue)) {
      const selectedObject = options.find(item => item.value === selectedValue);
      setSelected(selectedObject ? [selectedObject] : null);
  }
};

const customLabels = (selectedItem, label) => {
  if (!selectedItem || selectedItem.length === 0) {
      return label;
  }

  const [firstItem, ...remainingItems] = selectedItem;

  return remainingItems.length === 0 ? firstItem : `${firstItem} +${remainingItems.length}`;
};


  const customPhcLabels = (selectedPhc) => {
    return customLabels(selectedPhc, 'Select');
  };

  const customTalukaLabels = (selectedTaluka) => {
    return customLabels(selectedTaluka, 'Select');
  };
  return (
    <div
      className='apply-filter flex align-items-center bg-white justify-content-between'
      data-testid="filter"
      style={{ pointerEvents: 'none', opacity: 0.5 }}
    >

    {isFilterApplied && (
      <span>
        <img
          src={filter_list}
          className='p-overlay-badge'
          alt='filter_list'
        />
        <Badge className='filter-badge'></Badge>
      </span>
    )}
    {!isFilterApplied && (
      <img
        src={filter_list}
        alt='filter_list'
      />
    )}
      <div className='text-xs'>{t('filter')}</div>
      <OverlayPanel
      data-testid="open"
        ref={filterOverlay}
        closeOnEscape={false}
        dismissable={true}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='advSearchForm dashboard-filter'>
          <div className='flex flex-wrap gap-4 mb-3'>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0',marginLeft:'25px' }}
              >
                <label htmlFor='state'>State :</label>
              </div>
              <Dropdown
                id='state'
                value={searchState}
                data-testid='state-dropdown'
                options={['Maharashtra']}
                onChange={(e) => setSearchState(e.value)}
                placeholder='State'
                className='adv-dropdown'
                disabled
                style={{ marginLeft: '25px' }}
              />
            </div>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0' }}
              >
                <label htmlFor='districtName' style={{ marginLeft: '0.2rem' }}>
                  District Name :
                </label>
              </div>
              <div className='card flex'>
                <MultiSelect
                  id='districtName'
                  data-testid='district-dropdown'
                  value={selectedDistrict}
                  options={districtOptions}
                  optionLabel='label'
                  onChange={(e) => handleSelection(e.value, setSelectedDistrict, districtOptions)}
                  filter
                  placeholder='Select'
                  maxSelectedLabels={1}
                  className='adv-dropdown'
                  selectedItemsLabel={customLabels(selectedDistrict)}
                />
              </div>
            </div>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0' }}
              >
                <label htmlFor='talukaName' style={{ marginLeft: '0.2rem' }}>
                  Taluka Name :
                </label>
              </div>
              <div className='card flex'>
                <MultiSelect
                  id='talukaName'
                  data-testid='taluka-dropdown'
                  options={talukaOptions}
                  value={selectedTaluka}
                  onChange={(e) => handleSelection(e.value, setSelectedTaluka, talukaOptions)}
                  filter
                  placeholder='Select'
                  maxSelectedLabels={1}
                  className='adv-dropdown'
                  selectedItemsLabel={customTalukaLabels(selectedTaluka)}
                />
              </div>
            </div>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0' }}
              >
                <label htmlFor='phcName' style={{ marginLeft: '0.2rem' }}>
                  PHC Name :
                </label>
              </div>
              <div className='card flex'>
                <MultiSelect
                  data-testid='phc-dropdown'
                  value={selectedPhc}
                  options={phcOptions}
                  onChange={(e) => handleSelection(e.value, setSelectedPhc, phcOptions)}
                  maxSelectedLabels={1}
                  filter
                  placeholder='Select'
                  className='adv-dropdown'
                  selectedItemsLabel={customPhcLabels(selectedPhc)}
                />
              </div>
            </div>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0' }}
              >
                <label htmlFor='talukaName' style={{ marginLeft: '25px' }}>
                  Month :
                </label>
              </div>
              <div className='card flex'>
                <Dropdown
                  id='month'
                  data-testid='month'
                  value={searchMonth}
                  options={monthOptions}
                  onChange={(e) => setSearchMonth(e.value)}
                  placeholder='Month Name'
                  className='adv-dropdown'
                  style={{ marginLeft: '25px' }}
                />
              </div>
            </div>
            <div>
              <div
                className='font-semibold text-sm'
                style={{ margin: '10px 0' }}
              >
                <label htmlFor='talukaName' style={{ marginLeft: '10px' }}>
                  Year :
                </label>
              </div>
              <div className='card flex'>
                <Dropdown
                  id='year'
                  data-testid='year'
                  value={searchYear}
                  options={yearOptions}
                  onChange={(e) => setSearchYear(e.value)} 
                  placeholder='Select Year'
                  className='adv-dropdown'
                  style={{ marginLeft: '15px' }}
                />
              </div>
            </div>
          </div>
          <div className='flex gap-3 grid justify-content-center h-2rem font-bold border-round m-2'>
            <Button
              className='adv-resetBtn'
              data-testid='clear'
              label='Clear'
              onClick={handleClear}
            />
            <Button
              className='adv-searchBtn'
              data-testid='Apply'
              label='Apply'
              onClick={handleSearch}
            />
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
};
export default ApplyFilter;
